import React, { Component } from 'react';
import { CounsellingSchema, PatientNotAvailable, PatientCameOther, searchData } from '../../../schema/counsellor-counselling';
import { filter, formData, dissableFormData } from '../../../schema/apppointment';
import Select2 from '../../../components/FormComponent/select2';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Counselling_upload from '../../Counselling/newCounsellingForms/uploadDocument';
import { Modal, Spin, Button } from 'antd';
import { ReloadOutlined,CloseOutlined } from '@ant-design/icons';

import Storage from './../../../services/local-store';
import userTrackService from './../../../services/usertrack-service';
import Finanical_clearance from '../newCounsellingForms/uploadDocument';
import RadioButtonLayer from '../../../components/FormComponent/Input/radioButton'
const $ = require('jquery');
const {getPatientDischargeInitiationInfo, getPatientTrackbillInfo,getFcDetails, homepage}=networkList
class Counsellor_Token extends Component {
    constructor(props) {
        super(props)
        this.state = {
            'loadding': false,
            visible: false,
            response: true,
            PatientCameOther: [],
            success: false,
            tokenNumber: null,
            tokenData: [],
            showComments: false,
            comments: null,
            formData: [],
            nextTokenData: null,
            current_token_count: null,
            admission_date: null,
            skipReson:[],
            cousellingStationData:[],
            looping:0,
            break_status_log:false
        }
        // this.apiInterval = null; // To store the interval reference-- Reload issue
    }
    showModal = () => {
        let { PatientCameOther } = this.state;
        PatientCameOther.map((data, key) => {
            PatientCameOther[key]['errors'] = [];
            PatientCameOther[key]['value'] = null;
            PatientCameOther[key]['text'] = null;
            if (data.name === 'financial_couselling_skip') {
                PatientCameOther[key]['visible'] = false;
            }
        })
        this.setState({
            visible: true, 'PatientCameOther': PatientCameOther
        })
    }
    
    nextFCForm=()=>{
        let { responseData,form_type } = this.state;
        localStorage.removeItem('Patient_Counselling_has_already_done');
        if(responseData['previous_counselling_id']!==null && form_type==1){
            this.setState({visibleNext:true});
        }else{
            this.showFCForm();
        }

    }

    showFCForm = () => {

        this.setState((state) => ({ 'loadding': true,visibleNext:false }));
        let tokenData = JSON.parse(Storage.get('current_token'));
        let useData = JSON.parse(Storage.get('user_data'));
        let { nextPatientforQueue, saveOtherCounsellings } = networkList;
        let { responseData, formData, comments,form_type } = this.state;
        let This = this;
        let serviceType = tokenData['FC_PRIVILEGE_IDS'];
        let covid_status
        formData.map((feild, key) => {
            if (feild.name === 'service_type') {
                responseData['privilege_id'] = parseInt(feild.value);
            }
            if (feild.name === 'non-covid') {
                responseData['covid_status'] = 'Non-Covid'
                covid_status = 'Non-Covid'
                Storage.store('current_token', responseData)

            }
            if (feild.name === 'covid-ip' && feild.value) {
                responseData['covid_status'] = (feild.value && feild.title);

                covid_status = (feild.value && feild.title)
                Storage.store('current_token', responseData)

            }
            if (feild.name === 'covid-daycare' && feild.value) {
                responseData['covid_status'] = (feild.value && feild.title);
                covid_status = (feild.value && feild.title)
                Storage.store('current_token', responseData)

            }
            if (feild.name === 'covid-icu' && feild.value) {
                responseData['covid_status'] = (feild.value && feild.title);
                covid_status = (feild.value && feild.title)
                Storage.store('current_token', responseData)

            }
        })

        // let payload = {
        //     "doctor_Id": tokenData['doctor_id'],
        //     "umr": tokenData['umr'],
        //     "ip_number": tokenData['ip'],
        //     "patient_name": tokenData['patient_name'],
        //     "patient_mobile": tokenData['phone_number'],
        //     "patient_age": tokenData['age'],
        //     "patient_gender": tokenData['gender'],
        //     "service_id": responseData['privilege_id'],
        //     "token_number": tokenData['id'],
        //     "counselling_date": new Date(), // from backend
        //     "counsellor_id": useData['id'] ? useData['id'] : null, // from backend
        //     "comments": comments
        // }
        let selected_privilege_id = responseData['privilege_id']

        // if (responseData && responseData['privilege_id'] && !serviceType.includes(responseData['privilege_id'])) {



            // try {
            //     let obj = { 'id': responseData ? responseData['id'] : null }
            //     const Userlogobj ={
            //         "data": {
            //             "user": JSON.parse(localStorage.getItem('user')),
            //             "action": "Save Other Counsellings - Request",
            //             "date": new Date(),
            //             "meta": payload
            //         }
            //     }
            //     userTrackService(Userlogobj);
            //     postService(saveOtherCounsellings, 'POST', { 'data': payload }).then(res => {
            //         const Userlogobj ={
            //             "data": {
            //                 "user": JSON.parse(localStorage.getItem('user')),
            //                 "action": "Save Other Counsellings - Response",
            //                 "date": new Date(),
            //                 "meta": payload
            //             }
            //         } 
            //         userTrackService(Userlogobj);  
            //         if (res['status']) {
            //             const Userlogobjres ={
            //                 "data": {
            //                     "user": JSON.parse(localStorage.getItem('user')),
            //                     "action": "Next Patient for Queue - Request",
            //                     "date": new Date(),
            //                     "meta": payload
            //                 }
            //             }
            //             userTrackService(Userlogobjres);
            //             postService(nextPatientforQueue, 'POST', { 'data': obj }).then(res => {
            //                 const Userlogobjres ={
            //                     "data": {
            //                         "user": JSON.parse(localStorage.getItem('user')),
            //                         "action": "Next Patient for Queue - Response",
            //                         "date": new Date(),
            //                         "meta": payload
            //                     }
            //                 }
            //                 userTrackService(Userlogobjres);
            //                 if (res['status']) {
            //                     This.setState((state) => ({ 'PatientCameOther': PatientCameOther['feilds'], 'loadding': true, 'formData': CounsellingSchema['feilds'], 'tokenData': searchData['feilds'],'showComments': false, }), () => {

            //                         Modal.success({
            //                             title: 'Success Message',
            //                             content: 'Counselling Sucessfully Completed',
            //                             onOk: function () {
            //                                 window.scrollTo({
            //                                     top: 50,
            //                                     left: 0,
            //                                     behavior: 'smooth'
            //                                 });
            //                                 This.setState((state) => ({ 'loadding': false }));
            //                                 This.nextRenderBody()
            //                             }
            //                         })
            //                         // setTimeout(function () { This.renderBody(); }, 2000);

            //                     })
            //                 } else {
            //                     this.setState((state) => ({ 'loadding': false }));
            //                     if (res === 401) {

            //                     } else {
            //                         Modal.error({
            //                             title: 'Error Message',
            //                             content: 'Something is wrong. Please try again.',
            //                         })
            //                     }
            //                 }
            //             })
            //             this.setState((state) => ({ 'comments': null }));
            //         } else {
            //             this.setState((state) => ({ 'loadding': false }));
            //             if (res === 401) {

            //             } else {
            //                 Modal.error({
            //                     title: 'Error Message',
            //                     content: 'Something is wrong. Please try again.',
            //                 })
            //             }

            //         }
            //     })

            // } catch (error) {
            //     console.log(error);
            //     this.setState((state) => ({ 'loadding': false }));

            //     Modal.error({
            //         title: 'Error Message',
            //         content: 'Something is wrong. Please try again.',
            //     })

            // }



        // } else {
            let user_data = JSON.parse(Storage.get('user_data'));
            let current_token = JSON.parse(Storage.get('current_token'));
            let admission_date = null
            let payload = {
                "unit_id": user_data && user_data['unitid'] ? user_data['unitid'] : null,
                "ip_no": current_token && current_token['ip'] ? current_token['ip'] : null,
                "umr_no": current_token && current_token['umr'] ? current_token['umr'] : null

            }
            let selected_ip_no = current_token && current_token['ip'] ? current_token['ip'] : null
            let selected_umr_no = current_token && current_token['umr'] ? current_token['umr'] : null
            // if (covid_status !== null && covid_status !== undefined && covid_status !== "") {

            if (current_token && current_token['ip'] &&  (form_type && form_type==1)) {
                try {
                    postService(getPatientDischargeInitiationInfo, 'POST', { 'data': payload }).then(res => {
                        if (res.status) {
                            if (res['data'] && res['data'].length > 0) {
                                admission_date = res['data'][0]['admission_date']
                                let initiated = res['data'][0]['discharge_initiated']
                                if (initiated === 'YES') {
                                    Modal.info({
                                        title: `Information`,
                                        content: `You can't give an estimate to this patient. Patient discharge has been initiated. Please select "query privilege" and complete this token.`,
                                        zIndex: '1022'
                                    });
                                    this.setState({ loadding: false })
                                } else {
                                    this.setState({ loadding: false })
                                    // this.openFC(tokenData, admission_date)
                                    this.checkPatientTrackbill(tokenData, admission_date,selected_ip_no, selected_umr_no,selected_privilege_id)
                                }
                            } else {
                                this.setState({ loadding: false })
                                // this.openFC(tokenData, admission_date)
                                this.checkPatientTrackbill(tokenData, admission_date,selected_ip_no, selected_umr_no,selected_privilege_id)
                            }

                        } else {
                            // Modal.error({
                            //     title: `Failure`,
                            //     content: `${res.message}`,
                            //     zIndex: '1022'
                            // });
                            this.setState({ loadding: false })
                            // this.openFC(tokenData, admission_date)
                            this.checkPatientTrackbill(tokenData, admission_date,selected_ip_no, selected_umr_no,selected_privilege_id)
                        }

                    })
                } catch (error) {
                    console.log(error);
                    // this.openFC(tokenData, admission_date)
                    this.checkPatientTrackbill(tokenData, admission_date,selected_ip_no,selected_umr_no, selected_privilege_id)
                    this.setState((state) => ({ 'loadding': false }));
                    // Modal.error({
                    //     title: 'Error Message',
                    //     content: 'Oops, Something is wrong. Please try again.',
                    // })

                }
            } else {
                this.setState((state) => ({ 'loadding': false }));
                // this.openFC(tokenData, admission_date)
                this.checkPatientTrackbill(tokenData, admission_date,selected_ip_no, selected_umr_no,selected_privilege_id)
            }
        // }else {
        //     Modal.error({
        //         title: 'Error Message',
        //         content: 'Please Select Covid Status Of The Patient',
        //     })
        //     this.setState((state) => ({ 'loadding': false }));
        // }
        // }


    }

    checkPatientTrackbill = (tokenData, admission_date,selected_ip_no, selected_umr_no,selected_privilege_id) =>{

        if ((selected_umr_no || selected_ip_no) && selected_privilege_id == 5) {
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            try{
            postService(getPatientTrackbillInfo, 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    "ip_no": selected_ip_no ? selected_ip_no : null,
                    "umr_no":selected_umr_no ? selected_umr_no : null
                }
            }).then(res => {
                if (res.status) {
                    this.setState((state) => ({ 'loadding': false }));
                    if (res['data'] && res['data'].length > 0) {
                        let data = res['data'][0]['warning_flag']
                        // if(data){
                        this.openFC(tokenData, admission_date);
                        // }else{
                        //     Modal.info({
                        //         title: `Information`,
                        //         content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                        //         zIndex: '1022'
                        //     });
                        // }
                    } else {
                        Modal.info({
                            title: `Information`,
                            content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                            zIndex: '1022'
                        });
                    }
                } else {
                    this.setState((state) => ({ 'loadding': false }));
                    Modal.info({
                        title: `Information`,
                        content: `You can't do the "Recounselling" to this patient. He/She is not on the tracklist`,
                        zIndex: '1022'
                    });
                }
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: "Oops, something went wrong... Please try again.",
            });
        }
        } else {
            this.openFC(tokenData, admission_date)
        }
    }

    openFC = (tokenData, admission_date) => {
        let date = admission_date ? admission_date : null
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        localStorage.removeItem('room_eligible_ward_cost');
        localStorage.removeItem('payment');
        localStorage.removeItem('type_of_package');
        localStorage.removeItem('package_name');
        this.setState((state) => ({ 'loadding': false }));
        let { updateTokenCheckin } = networkList;

        try {
            postService(updateTokenCheckin, 'POST', { 'data': { "id": tokenData.id, "token_datetime": tokenData.token_datetime } }).then(res => {
                const obj = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "Next for Counsellor",
                        "date": new Date(),
                        "meta": ""
                    }
                }
                userTrackService(obj);
                console.log('res:', res)
                if (res['status']) {
                   
                    // const current_token = JSON.parse(Storage.get('current_token'))
                    localStorage.removeItem('current_print');

                    if (tokenData['previous_counselling_id'] !== '' && tokenData['previous_counselling_id'] !== null && tokenData['previous_counselling_id'] !== undefined) {
                        console.log('here')
                        localStorage.setItem('est_admis_date',date)
                        this.props.history.push('/counselling/finanical-counselling?rid=' + tokenData['previous_counselling_id']);
                    }
                    else {
                        console.log('else')
                        // this.props.history.push('/counselling/finanical-counselling');
                        this.props.history.push({ pathname: "/counselling/finanical-counselling", state: { 'est_admis_date': date } })
                    }
                

                    // if (tokenData['previous_counselling_id'] === null) {
                    //     this.props.history.push({ pathname: "/counselling/finanical-counselling", state: { 'est_admis_date': date } })
                    // } else {
                    //     this
                    //         .props
                    //         .history
                    //         .push(`/counselling/finanical-counselling?rid=${tokenData['previous_counselling_id']}`);
                    // }
                };/////////////////////
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    successModal = () => {
        // this.setState({
        //     success: true,
        //     visible: false
        // })

        let { skipPatientfromQueue } = networkList;
        let { responseData, PatientCameOther,skipReson } = this.state;
        let obj = {
            'id': responseData ? responseData['id'] : null,
            "skip_reason_id": null,
            "privilege_id": null,
            "token_no":responseData['id']
        }
        let errors = [];
        let reason = null;
        PatientCameOther.map((data, key) => {
            if (data.name === 'reason_dropdown') {
                if (data.value !== null) {
                    reason = data.value;
                    obj['skip_reason_id'] = data.value;
                } else {
                    errors.push(false);
                    PatientCameOther[key]['errors'] = [{ 'message': 'Please select Reason' }]
                }
            }
            if (data.name === 'financial_couselling_skip') {
                if (data.value !== null && reason === 1) {
                    obj['privilege_id'] = data.value;
                } else {
                    obj['privilege_id'] = skipReson['privilege_id'];
                }
                if (data.value === null && reason === 1) {
                    errors.push(false)
                    PatientCameOther[key]['errors'] = [{ 'message': 'Please select Service type' }]
                }

            }
        })
        let This = this;
        if (!errors.includes(false)) {
            console.clear();
            console.log(obj);

            //  return true;
            // postService(skipPatientfromQueue, 'POST', { 'data': obj }).then(res => {
            //     if (res['status']) {
            //         This.setState((state) => ({ visible: false, 'PatientCameOther': PatientCameOther['feilds'], 'loadding': true, 'formData': CounsellingSchema['feilds'], 'tokenData': searchData['feilds'] }), () => {

            //             Modal.success({
            //                 title: 'Success Message',
            //                 content: 'Token updated with new Service',
            //                 onOk: function () {
            //                     window.scrollTo({
            //                         top: 50,
            //                         left: 0,
            //                         behavior: 'smooth'
            //                     });

            //                     This.renderBody()
            //                 }
            //             })


            //             // setTimeout(function () { This.renderBody(); }, 2000);

            //         })
            //     } else {
            //         Modal.error({
            //             title: 'Error Message',
            //             content: 'Token is not Updated, Please try again.',
            //         })
            //     }
            // })

            // return true;
            let message = null;
            if (obj['skip_reason_id'] === 2) {
                message = "Token Skipped Successfully";
            } else {
                message = 'Token updated with new Service'
            }
                    const Userlogobj ={
                        "data": {
                            "user": JSON.parse(localStorage.getItem('user')),
                            "action": "Skip Patient from Queue - Request",
                            "date": new Date(),
                            "meta": obj
                        }
                    }
                    userTrackService(Userlogobj);
                    postService(skipPatientfromQueue, 'POST', { 'data': obj }).then(res => {
                        const Userlogobjres ={
                            "data": {
                                "user": JSON.parse(localStorage.getItem('user')),
                                "action": "Skip Patient from Queue - Response",
                                "date": new Date(),
                                "meta": res
                            }
                        }
                        userTrackService(Userlogobjres);
                        if (res['status']) {
                            Modal.success({
                                title: 'Success Message',
                                content: message,
                            })
                            let breaStatus=res['break_status']?res['break_status']:false;
                            localStorage.removeItem('Patient_Counselling_has_already_done');
                            This.setState((state) => ({ visible: false, 'PatientCameOther': PatientCameOther, 'loadding': true, 'formData': CounsellingSchema['feilds'], 'tokenData': searchData['feilds'],'showComments': false,break_status_log:breaStatus }), () => {
                                window.scrollTo({
                                    top: 50,
                                    left: 0,
                                    behavior: 'smooth'
                                });

                                This.nextRenderBody()
                                // setTimeout(function () { This.renderBody(); }, 2000);

                            })
                        }else {
                            this.setState({ loadding: false});
                            let that=this
                            Modal.warning({
                                title: 'Unable to process',
                                content: res.message?res.message:'Oops! something went wrong. Please,try again later',
                                zIndex:'1035',
                                onOk() {
                                    Storage.store('Patient_Counselling_has_already_done', res.data);
                                    that.props.history.push({ pathname: "/counselling/finanical-counselling"})
                                    // that.props.next();
                                        }
                            });
                        }
                        //  else {
                        //     if (res === 401) {

                        //     } else {
                        //         Modal.error({
                        //             title: 'Error Message',
                        //             content: 'Token is not Updated, Please try again.',
                        //         })
                        //     }

                        // }
                    })


              

            this.setState((state) => ({ 'comments': null }));
        } else {
            this.setState((state) => ({ 'PatientCameOther': PatientCameOther }))
        }

    }

    handleCancel = e => {
        console.log(e)
        this.setState({ visible: false })
    }
    handleCancelNext = e =>{
       this.setState({visibleNext:false}) 
    }
    successCancel = e => {
        console.log(e)
        this.setState({ success: false })
    }



    componentDidMount() {
        // this.checkTokenStatus(); // Check the token status immediately-- Reload issue
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        this.setState((state) => ({ 'PatientCameOther': PatientCameOther['feilds'], 'loadding': true, 'formData': CounsellingSchema['feilds'], 'tokenData': searchData['feilds'] }), () => {
            this.renderBody();
            this.checkBreak();
            this.getCounsellingStationsByUser();
        })
    }

    getCounsellingStationsByUser(){
        postService('getCounsellingStationsByUser', 'GET', 'null').then(async res => {
            if (res) {
                let couselling_station_id = localStorage.getItem('couselling_station_name');
               let cousellingStationData= res.data.filter((item)=>item.counselling_station_id===couselling_station_id)
               this.setState({cousellingStationData:cousellingStationData})
            }
        })
    }


    componentWillUnmount(){
        // this.clearPolling(); // Clear the interval when the component is unmounted-- Reload issue
        clearInterval(this.checkPatient);
    }
    //new - token assigning-- Reload issue
    // checkTokenStatus = () => {
    //     // Call the API immediately
    //     this.renderBody();

    //     // Start polling only if no token is assigned
    //     let user_data = JSON.parse(Storage.get('user_data'));
    //     // if (!this.state.nextTokenData && user_data.unitid === 'UN1') {
    //         this.startPolling();
    //     // }
    // };
    // //-- Reload issue
    // startPolling = () => {
    //     // Clear any existing interval to avoid duplicates
    //     this.clearPolling();

    //     // Start a new interval for polling
    //     this.apiInterval = setInterval(() => {
    //         if (!this.state.nextTokenData) {
    //             this.renderBody();
    //         } else {
    //             this.clearPolling(); // Stop polling if token is assigned
    //         }
    //     }, 30000); // Poll every 30 seconds
    // };

    // //-- Reload issue
    // clearPolling = () => {
    //     if (this.apiInterval) {
    //         clearInterval(this.apiInterval);
    //         this.apiInterval = null;
    //     }
    // };

    checkBreak = () => {
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "get User Break Status - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService('getUserBreakStatus', 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get User Break Status - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                if (res['data'] && res['data']['break_status'] && res['data']['break_status'] === 1) {
                    this.props
                        .history
                        .push(`/counselling/start`);
                }
                // this.setState({ 'break_status': res['data']['break_status'] })
                // console.log(res);
            } else {
                this.setState({ 'break_status': 0 })
            }
        });
    }

    handleChange(attr) {
        let tokenData = JSON.parse(Storage.get('current_token'));
        let { formData, PatientCameOther } = this.state;
        let showComments = false;
        let comments = null;
        formData.map((form, key) => {
            if (form.name === attr.name && form.name === "service_type") {
                formData[key]['value'] = attr.value;
                formData[key]['text'] = attr.text;
                if (!tokenData['FC_PRIVILEGE_IDS'].includes(attr.value)) {
                    showComments = true;
                } else {
                    showComments = false;
                }
               
            }
            if (attr.name === 'non-covid') {
                if (form.name === "non-covid") {
                    formData[key]['value'] = attr.value;
                }
                if (form.name === "covid-ip") {
                    formData[key]['value'] = null;
                }
                if (form.name === "covid-daycare") {
                    formData[key]['value'] = null;
                }
                if (form.name === 'covid-icu') {
                    formData[key]['value'] = null;
                }
            }
            if (attr.name === 'covid-ip') {
                if (form.name === "non-covid") {
                    formData[key]['value'] = null;
                }
                if (form.name === "covid-ip") {
                    formData[key]['value'] = attr.value;
                }
                if (form.name === "covid-daycare") {
                    formData[key]['value'] = null;
                }
                if (form.name === 'covid-icu') {
                    formData[key]['value'] = null;
                }
            }
            if (attr.name === 'covid-daycare') {
                if (form.name === "non-covid") {
                    formData[key]['value'] = null;
                }
                if (form.name === "covid-ip") {
                    formData[key]['value'] = null;
                }
                if (form.name === "covid-daycare") {
                    formData[key]['value'] = attr.value;
                }
                if (form.name === 'covid-icu') {
                    formData[key]['value'] = null;
                }
            }
            if (attr.name === "covid-icu") {
                if (form.name === "non-covid") {
                    formData[key]['value'] = null;
                }
                if (form.name === "covid-ip") {
                    formData[key]['value'] = null;
                }
                if (form.name === "covid-daycare") {
                    formData[key]['value'] = null;
                }
                if (form.name === 'covid-icu') {
                    formData[key]['value'] =  attr.value;
                }
        }
        })
        if (attr.name === "service_type") { 
            let playload = JSON.parse(Storage.get('current_token'));
            Object.assign(playload, { form_type_id: attr.form_type });
            Object.assign(playload, { privilege_id: attr.value });
            Object.assign(playload, { privilege_name: attr.text });
            Storage.store('current_token', playload);
            this.setState({ form_type: attr.form_type,responseData:playload })
        }

        let reason = null;
        PatientCameOther.map((form, key) => {
            if (form.name === 'reason_dropdown') {
                reason = form.value;
            }
            if (reason === 2 && form.name === 'financial_couselling_skip') {
                PatientCameOther[key]['disable'] = true;
                PatientCameOther[key]['visible'] = false;

            }

            if (reason === 1 && form.name === 'financial_couselling_skip') {
                PatientCameOther[key]['disable'] = false;
                PatientCameOther[key]['visible'] = true;
            }

            if (form.name === attr.name) {
                PatientCameOther[key]['value'] = attr.value;
                PatientCameOther[key]['text'] = attr.text;
            }
        })

        this.setState((state) => ({ 'comments': null, 'showComments': showComments, 'PatientCameOther': PatientCameOther, 'formData': formData }))

    }

    renderBody() {
        clearInterval(this.checkPatient);
        let { startAssignTokenToCounsellor } = networkList;
        let { tokenData, formData, } = this.state;
        let user_data = JSON.parse(Storage.get('user_data'));
        let showComments = false;
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Start Assign Token To Counsellor - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService(startAssignTokenToCounsellor, 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Start Assign Token To Counsellor - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                this.setState((state) => ({ responseData: res['data'], 'response': true,skipReson:res['data'] }), () => {
                    let { responseData } = this.state;
                    tokenData.map((d, i) => {
                        if (d.name === 'name') {
                            tokenData[i]['value'] = responseData['patient_name'];
                        }
                        if (d.name === 'umr_number') {
                            tokenData[i]['value'] = responseData['umr'];
                        }

                        if (d.name === 'gender') {
                            if (responseData['gender'] == 'male') {
                                tokenData[i]['value'] = 'Male';
                            } else {
                                tokenData[i]['value'] = 'Female';
                            }
                        }
                        if (d.name === 'age') {
                            tokenData[i]['value'] = responseData['age'];
                        }
                        if (d.name === 'ip') {
                            tokenData[i]['value'] = responseData['ip'];
                        }

                        if (d.name === 'phone_number') {
                            tokenData[i]['value'] = responseData['phone_number'];
                        }
                        if (d.name === 'doctor_name') {
                            tokenData[i]['value'] = responseData['doctor_name'];
                        }

                    })

                    formData.map((form, key) => {
                        if (form.name === 'service_type') {
                            formData[key]['value'] = responseData['privilege_id'];
                            formData[key]['text'] = responseData['privilege_name'];
                        }
                        if (form.name === 'non-covid') {
                            form.value = null;

                        }
                        if (form.name === 'covid-ip') {
                            form.value = null;

                        }
                        if (form.name === 'covid-daycare') {
                            form.value = null;

                        }
                        if (form.name === 'covid-icu') {
                            formData[key]['value'] =null;
                        }
                    })
                   
                    if (responseData['FC_PRIVILEGE_IDS'] && !responseData['FC_PRIVILEGE_IDS'].includes(parseInt(responseData['privilege_id']))) {
                        showComments = true;
                    }
                    //responseData['form_type_id'] = 1
                    // localStorage.setItem('current_token', responseData);
                    Storage.store('current_token', responseData);
                    this.setState((state) => ({ 'showComments': showComments, 'PatientCameOther': PatientCameOther['feilds'], 'loadding': false, 'formData': formData, 'tokenData': tokenData, 'tokenNumber': responseData['token_display_id'], 'current_token_count': responseData['current_token_count'],form_type:responseData['form_type_id'],'response': true }))
                })
            } else {
                if (res['data'] && Array.isArray(res['data']) && res['data'].length === 0) {
                    // Modal.info({
                    //     'title': 'Message',
                    //     'content': 'No Patients For Counselling.'
                    // })
                }
                this.checkPatientdata();
                this.checkPatient = setInterval(() => {
                    this.checkPatientdata();
                    this.checkBreak();
                    //-- Reload issue
                    // if(user_data.unitid === 'UN1'){
                        // this.renderBody();
                    // }
                // }, 30000)
            }, 40000)
                this.setState((state) => ({ 'response': false, loadding: false }));
            }
        });



    }


    nextRenderBody() {
        let { nextAssignTokenToCounsellor, checkTokenforAssign } = networkList;
        let { tokenData, formData, } = this.state;

        let showComments = false;
        this.setState((state) => ({ 'response': false, loadding: true }));
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "next Assign Token To Counsellor- Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService(nextAssignTokenToCounsellor, 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "next Assign Token To Counsellor- Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                    this.setState((state) => ({ responseData: res['data'], 'current_token_count': res['data']['current_token_count'],'response': true,skipReson:res['data'] }), () => {
                        let { responseData } = this.state;
                        tokenData.map((d, i) => {
                            if (d.name === 'name') {
                                tokenData[i]['value'] = responseData['patient_name'];
                            }
                            if (d.name === 'umr_number') {
                                tokenData[i]['value'] = responseData['umr'];
                            }

                            if (d.name === 'gender') {
                                if (responseData['gender'] == 'male') {
                                    tokenData[i]['value'] = 'Male';
                                } else {
                                    tokenData[i]['value'] = 'Female';
                                }
                            }
                            if (d.name === 'age') {
                                tokenData[i]['value'] = responseData['age'];
                            }
                            if (d.name === 'ip') {
                                tokenData[i]['value'] = responseData['ip'];
                            }

                            if (d.name === 'phone_number') {
                                tokenData[i]['value'] = responseData['phone_number'];
                            }
                            if (d.name === 'doctor_name') {
                                tokenData[i]['value'] = responseData['doctor_name'];
                            }

                        })

                        formData.map((form, key) => {
                            if (form.name === 'service_type') {
                                formData[key]['value'] = responseData['privilege_id'];
                                formData[key]['text'] = responseData['privilege_name'];
                            }
                        })

                        if (!responseData['FC_PRIVILEGE_IDS'].includes(parseInt(responseData['privilege_id']))) {
                            showComments = true;
                        }

                        // localStorage.setItem('current_token', responseData);
                        //responseData['form_type_id'] = 1;
                        Storage.store('current_token', responseData);
                        this.setState((state) => ({ 'showComments': showComments, 'PatientCameOther': PatientCameOther['feilds'], 'loadding': false, 'formData': formData, 'tokenData': tokenData, 'tokenNumber': responseData['token_display_id'],'response': true }))
                    })
                

            } else {
                let This = this;
                if (res['data'] && Array.isArray(res['data']) && res['data'].length === 0) {
                    Modal.info({
                        'title': 'Message',
                        'content': 'No Patients For Counselling.',
                        onOk:()=>{
                            This.checkBreak()
                        }
                    })
                }
                
                this.checkPatientdata();
                This.checkBreak()
                this.renderBody()
                this.checkPatient = setInterval(() => {
                    this.checkPatientdata();
                    this.checkBreak();
                    this.renderBody()
                   

                }, 40000)
                this.setState((state) => ({ 'response': false, loadding: false }), () => {

                });
            }
        });
    }

    checkPatientdata() {
        let { nextAssignTokenToCounsellor, checkTokenforAssign } = networkList;
        let This=this
        let {looping,break_status_log}=this.state
        const Userlogobj ={
            "data": {
                "user": JSON.parse(localStorage.getItem('user')),
                "action": "Check Token for Assign - Request",
                "date": new Date(),
                "meta": null
            }
        }
        userTrackService(Userlogobj);
        postService(checkTokenforAssign, 'GET', 'null').then(res => {
            const Userlogobjres ={
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "Check Token for Assign - Response",
                    "date": new Date(),
                    "meta": res
                }
            }
            userTrackService(Userlogobjres);
            if (res.status) {
                if(!break_status_log){
                   This.renderBody(); 
                }
                
                this.setState((state) => ({ 'nextTokenData': res['data'],skipReson: res['data'],'response': true,looping:1 }))
               
            } else {
                this.setState((state) => ({ 'nextTokenData': null,looping:0 }))
            }
        })
    }
    previousCounselling =() => {
        let {responseData,form_type}=this.state;
        // this.setState({visibleNext:false})
        let payload = {
            "counselling_id": responseData['previous_counselling_id'] ? parseInt(responseData['previous_counselling_id']) : null
        }
        postService(getFcDetails, 'POST', { "data": payload }).then(res => {
            if (res.status && res.data) {
                    window.open(`${homepage}/counselling/view-finanical-counselling?pid=${res.data[0].payment_type_id}&cid=${responseData['previous_counselling_id']}&fid=${form_type}`, '_blank', 'noopener,noreferrer');
                
            }
        });
    }



    // comments(event) {
    //     let value = event.target.value;
    //     this.setState((state) => ({ 'comments': value ? value : null }));
    // }

    render() {
        let { tokenData, tokenNumber, formData, PatientCameOther, showComments, comments, response, nextTokenData, current_token_count,cousellingStationData } = this.state

        let token_disaply = nextTokenData ? nextTokenData['token_display_id'] ? nextTokenData['token_display_id'] : null : null;
        let current_token_count_disaply = nextTokenData ? nextTokenData['current_token_count'] ? nextTokenData['current_token_count'] : null : null;
        let privilege_name = nextTokenData ? nextTokenData['privilege_name'] ? nextTokenData['privilege_name'] : null : null;
        return (
            <React.Fragment>
                <div className="row mx-5 mt-3 mb-5">
                    <div className={`col-12`}>
                    {/* {showComments? `col-10 p-0` : `col-12`} */}
                        <div className="card p-5">
                            {(response) && <React.Fragment>

                                <h1 className="text-center text-capitalize text-heading pb-5">token number {(current_token_count !== null) ? current_token_count : '--'}</h1>
                                <div className="row w-100 mx-auto pb-4">

                                    {tokenData.map((data, key) => {
                                        if(data.name=='counselling_station'){
                                            return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                                            <p className="data-label pr-1">{data.title}</p>
                                            <p className="data-item"> : {(cousellingStationData && cousellingStationData.length>0)?cousellingStationData[0].counselling_station_name : '--'}</p>
                                        </div>)
                                        }else{
                                            return (<div className="col-xl-4 col-lg-4 col-sm-6 d-flex">
                                            <p className="data-label pr-1">{data.title}</p>
                                            <p className="data-item"> : {(data.value && data.value !== null) ? data.value : '--'}</p>
                                        </div>)
                                        }
                                       
                                    })}
                                </div>
                                <div className="row w-100 mx-auto">
                                    {formData
                                        .map((feild, key) => {

                                            if (feild.element === 'select2') {
                                                return (
                                                    <div class="col-12 mt-3 mb-5">
                                                        {(feild.name === 'patient_list' && feild.disable === false) &&
                                                            <div className="col-6">
                                                                <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                            </div>}
                                                        <label className="data-label w-100">{feild.title}</label>
                                                        <Select2
                                                            selectdata={feild}
                                                            changedObj={this.state.changedObj}
                                                            {...this.props}
                                                            {...this.state}
                                                            Queuedata={this.state.formData}
                                                            onselectChanges={this
                                                                .handleChange
                                                                .bind(this)} />
                                                        {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}

                                                    </div>
                                                )
                                            }
                                            if (feild.visible && feild.element === 'radio') {
                                                return (<div class="col-2 mb-5">
                                                    {(feild.name === 'patient_list' && feild.disable === false) &&
                                                        <div className="col-6">
                                                            <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                        </div>}
                                                    {/* <label className="data-label w-100">{feild.title}</label> */}
                                                    <RadioButtonLayer selectdata={feild}
                                                        changedObj={this.state.changedObj}
                                                        {...this.props}
                                                        {...this.state}
                                                        Queuedata={this.state.formData}
                                                        onselectChanges={this.handleChange.bind(this)} style={{ disply: 'flex' }} />
                                                    {feild.errors.map((error, eKey) => {
                                                        return (
                                                            <small key={eKey} className="form-text text-danger" style={{ bottom: '-15px' }}>{error.message}</small>
                                                        );

                                                    })}

                                                </div>)
                                            }
                                            if (feild.visible && feild.element === 'text') {
                                                return (<div className="col-xl-12 col-lg-12 col-sm-12 d-flex">
                                                    <p className="data-label pr-1">{feild.title}</p>
                                                </div>)

                                            }
                                        })}
                                </div>
                                {/* {(showComments) &&
                                    <div className="row w-100 mx-auto">
                                        <div class="col-12 pb-5">
                                            <textarea placeholder="comment" className="textarea" value={comments ? comments : ''} onChange={(event) => this.comments(event)} autoFocus></textarea>
                                        </div>
                                    </div>}                            */}
                                <div className="row justify-content-center">
                                    <button className="btn btn-success btn-next text-capitalize mr-3" onClick={this.showModal}>skip</button>
                                    <button className="btn btn-success text-capitalize" onClick={this.nextFCForm}>next</button>
                                    {/* <button className="btn btn-success text-capitalize" onClick={this.showFCForm}>next</button> */}
                                </div>
                            </React.Fragment>}
                            {(!response) && <React.Fragment>
                                <div className="row mx-auto">
                                    <div className="col-12 text-center">
                                        <p className="data-item mb-0" style={{ fontSize: '2pc' }}>{nextTokenData ? 'A New Token is Waiting in the Queue for Your Counselling.' : 'No Patients For Counselling.'}</p>
                                    </div>
                                    <div className="col-12 text-center">
                                        <p className="data-item mb-0" style={{ fontSize: '4pc' }}>{current_token_count_disaply}</p>
                                        <p className="data-item mb-0" style={{ fontSize: '0.9pc' }}>{privilege_name}</p>

                                    </div>

                                    <div className="col-12 text-center mt-3" >
                                        <Button type="primary" onClick={this.renderBody.bind(this)}>
                                            {nextTokenData ? 'Start Counselling' : 'Reload'}</Button>
                                    </div>
                                </div>
                            </React.Fragment>}

                            <Modal visible={this.state.success} onCancel={this.successCancel} footer={null}>
                                <div className="text-center token-popup p-5">
                                    <h3 className="text-success">Transaction Completed</h3>
                                </div>
                            </Modal>

                            <Modal visible={this.state.visible} onCancel={this.handleCancel} footer={null}>
                                <div className="token-popup">
                                    <h3>Are you sure you want to skip the patient?</h3>
                                    {PatientCameOther
                                        .map((feild, key) => {

                                            if (feild.element === 'select2' && feild.visible) {
                                                return (
                                                    <div class="col-12 mt-3 mb-2">
                                                        <label className="data-label w-100 text-left">{feild.title}</label>
                                                        <Select2
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={this
                                                                .handleChange
                                                                .bind(this)}
                                                        // onselectChanges={this
                                                        //     .formonChange
                                                        //     .bind(this)}
                                                        /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}

                                                    </div>
                                                )
                                            }
                                        })}
                                    <div className="row justify-content-center pt-4">
                                        <button className="btn btn-success btn-next text-capitalize mr-3" onClick={this.successModal}>submit</button>
                                        <button className="btn btn-success text-capitalize" onClick={this.handleCancel}>Close</button>
                                    </div>
                                </div>
                            </Modal>
                             <Modal visible={this.state.visibleNext} footer={null}>
                             <CloseOutlined type="close" className=" popup-close" onClick={this.handleCancelNext} />
                                <div className="token-popup">
                                    <h3>This patient having recent counselling record available. Click preview to view the record.</h3>
                                    <div className="row justify-content-center pt-4 ">
                                        <button className="btn btn-success btn-next text-capitalize mr-3" onClick={this.previousCounselling}>Preview</button>
                                        <button className="btn btn-success text-capitalize" onClick={this.showFCForm}>Continue</button>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        </div>
                    {/* <div className={showComments ? `col-2 pl-1 pr-0` : `d-none`}>
                        {(showComments) &&  <div className="card p-3 right-panel-sticky">
                            <h4 className="text-center pb-3">Other Info</h4>
                            <Counselling_upload {...this.props} {...this.state} />
                            <Finanical_clearance {...this.props} {...this.state} />
                    </div>}
                    </div> */}
                </div>
                {(this.state.loadding) &&
                    <div className="loadding"> <Spin spinning={true}></Spin></div>}
            </React.Fragment>
        )

    }
}
export default Counsellor_Token;